import { SetActiveRoute } from "Store/application";
import { Store } from "Store/index";
import { ThunkAction } from "redux-thunk";
import { DEFAULT_ROUTES } from "Config/routes";

/** Publishes a new active route to the Store. */
export function setActiveRoute(
  path: Store["application"]["active_route"]["path"]
): ThunkAction<SetActiveRoute, Store, undefined, SetActiveRoute> {
  return (dispatch, getState) => {
    if (path.length > 1 && path[path.length - 1] === "/") {
      path = path.slice(0, path.length - 1);
    }

    let route = getState().application.routes.find(
      route => route.path === path
    );

    if (route === undefined) {
      route = DEFAULT_ROUTES["error"];
      window.location.pathname = "error";
    }

    return dispatch({
      type: "APPLICATION__SET_ACTIVE_ROUTE",
      route: {
        id: route.id,
        path: route.path
      }
    });
  };
}
